<template>
  <div class="section-empty">
    <i v-if="icon" class="fa-regular fa-2x" :class="icon"></i>
    <p>{{ message }}</p>
    <div v-if="$slots.default" class="section-empty__actions">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    icon:    { type: String, default: 'fa-inbox' },
    message: { type: String, default: '' },
  },
};
</script>

<style lang="scss" scoped>
.section-empty {
  text-align: center;
  margin-bottom: 20px;
  padding: 32px 16px;
  color: #bbb;
  border: 2px dashed #e8e8e8;
  border-radius: 8px;

  p {
    margin: 10px 0 0;
    font-size: 0.9em;
  }

  &__actions {
    margin-top: 14px;
  }
}
</style>
